import React from 'react';
import { CustomModalLayout } from '@wix/design-system';
const NewAppSettingsModal = (props) => {
    const { settingsUrl, closeModal } = props;
    React.useEffect(() => window.addEventListener('message', (msg) => {
        return () => window.removeEventListener('message', () => closeModal());
    }), []);
    return (React.createElement(CustomModalLayout, { onCloseButtonClick: closeModal, removeContentPadding: true, width: "600px" },
        React.createElement("iframe", { src: settingsUrl, width: "100%", height: "463px", frameBorder: "0" })));
};
export default NewAppSettingsModal;
//# sourceMappingURL=new-app-settings-modal.js.map